import styles from "components/Slider/Slider.module.css";

interface IProps {
    checked: boolean;
    id?: string;
    name?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    size?: number;
}

/** Displays a toggle slider for a checkbox input
 * @param checked - Whether the checkbox is checked, would usually be something like
 * formData.enabled if this were not its own component
 * @param id - ID of the checkbox
 * @param name - Name of the checkbox
 * @param onChange - Function to handle the change of the checkbox
 * @param size - Size to scale the checkbox, defaults to 1
 */
export default function Slider({
    checked,
    id,
    name,
    onChange,
    size = 1,
}: IProps) {
    const style = { transform: `scale(${size})` };

    return (
        <label style={style} className={styles.enableSwitch}>
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
            />
            <span className={styles.slider} />
        </label>
    );
}
